/**
 * backgroundGenStore — SSE 끊긴 후 백그라운드 생성 추적 (Zustand)
 *
 * studio-generate SSE 스트림이 모달 닫힘으로 끊긴 후,
 * 서버에서 아직 생성 중임을 UI에 표시하기 위한 스토어.
 * sessionStorage에 persist되어 새로고침에도 유지된다.
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface BackgroundGen {
  /** 요청한 총 장수 */
  count: number
  /** SSE 끊기기 전까지 받은 image 이벤트 수 */
  completedSoFar: number
  /** ISO timestamp — 이후 generation 감지 기준 */
  startedAt: string
  /** 앨범 ID (있으면) */
  albumId?: string
}

interface BackgroundGenState {
  current: BackgroundGen | null
  start: (gen: BackgroundGen) => void
  clear: () => void
}

export const useBackgroundGenStore = create<BackgroundGenState>()(
  persist(
    (set) => ({
      current: null,
      start: (gen) => set({ current: gen }),
      clear: () => set({ current: null }),
    }),
    {
      name: 'cugumi-background-gen',
      storage: {
        getItem: (name) => {
          const value = sessionStorage.getItem(name)
          return value ? JSON.parse(value) : null
        },
        setItem: (name, value) => sessionStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => sessionStorage.removeItem(name),
      },
    },
  ),
)
